import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Loader from '../../common/loader';
import {
  getCustomerParty,
  getMailingAddress,
  getPrimaryPhoneInfo,
  getSecondaryPhoneInfo,
} from './selectors';
import { setEmailErrors, setPhoneErrors } from './profileReducer';
import {
  LoaderMargin,
  MailingAddressContainer,
  MailingAddressLabel,
  NameContainer,
  NameLabel,
  OnlineProfileHeader,
  OuterProfileContainer,
  ProfileDetailsContainer,
  ProfileMailingAddress,
} from './styles';
import PhoneDetails from './phoneDetails';
import EmailDetails from './emailDetails';

export const ProfileDetails = props => {
  const { isLoading, profileMailingAddress, profileName } = props;

  React.useEffect(() => {
    props.dispatch(setEmailErrors(null));
    props.dispatch(setPhoneErrors(null));
  }, []);

  const getMailingAddressLineOne = () => {
    const { addr1 } = profileMailingAddress;
    return `${addr1 || ''}`;
  };
  const getMailingAddressLineTwo = () => {
    const { city, stateProvCd, postalCode } = profileMailingAddress;
    return `${city || ''}${city ? ',' : ''} ${stateProvCd || ''} ${postalCode || ''}`;
  };

  return (
    <OuterProfileContainer>
      <OnlineProfileHeader>Customer Information</OnlineProfileHeader>
      {isLoading ? (
        <LoaderMargin>
          <Loader />
        </LoaderMargin>
      ) : (
        <ProfileDetailsContainer>
          <NameContainer>
            <NameLabel>Name:</NameLabel>
            {profileName}
          </NameContainer>
          <MailingAddressContainer>
            <MailingAddressLabel>Mailing Address:</MailingAddressLabel>
            <ProfileMailingAddress>
              {getMailingAddressLineOne()} <br />
              {getMailingAddressLineTwo()}
            </ProfileMailingAddress>
          </MailingAddressContainer>
          <PhoneDetails isDashboard={true} />
          <EmailDetails isDashboard={true} />
        </ProfileDetailsContainer>
      )}
    </OuterProfileContainer>
  );
};

ProfileDetails.propTypes = {
  dispatch: PropTypes.func,
  isLoading: PropTypes.bool,
  profileName: PropTypes.string,
  profileMailingAddress: PropTypes.object,
  phoneNumberPrimary: PropTypes.string,
  phoneNumberSecondary: PropTypes.string,
  emailAddress: PropTypes.string,
  phoneErrors: PropTypes.any,
  emailErrors: PropTypes.any,
  editingEmail: PropTypes.bool,
  editingPhone: PropTypes.bool,
  primaryPhoneNameType: PropTypes.string,
  secondaryPhoneNameType: PropTypes.string,
};
const mapStateToProps = state => ({
  isLoading: state.billingSlice.isLoading,
  phoneErrors: state.profileSlice.phoneErrors,
  emailErrors: state.profileSlice.emailErrors,
  editingEmail: state.profileSlice.editingEmail,
  editingPhone: state.profileSlice.editingPhone,
  profileMailingAddress: getMailingAddress(state),
  profileName: state.customerSlice.customer.indexName,
  phoneNumberPrimary: getPrimaryPhoneInfo(state).phoneNumber,
  phoneNumberSecondary: getSecondaryPhoneInfo(state).phoneNumber,
  emailAddress: getCustomerParty(state).emailInfo
    ? getCustomerParty(state).emailInfo.emailAddr
    : '',
  primaryPhoneNameType: getPrimaryPhoneInfo(state).phoneName,
  secondaryPhoneNameType: getSecondaryPhoneInfo(state).phoneName,
});
ProfileDetails.defaultProps = {
  state: {},
};

export default connect(mapStateToProps)(ProfileDetails);
